//SDK //API
export class SDKManager {
    private totalAdsCount: number = 1;
    public adsWatchedCount: number = 1; // Reset to 0 to activate ads.

    public static canCheckRoadTexture: boolean = false;

    public static isFirstTime: boolean = false;
    public static quitGame: boolean = false;

    public static getPlayerFirstTimeMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_isPlayerFirstTime');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerFirstTimeMetaData(true);
        } else {
            SDKManager.isFirstTime = Boolean(data.isPlayerFirstTime);
        }
    }

    public static setPlayerFirstTimeMetaData(value: boolean) {
        localStorage.setItem('hammerplay_rampageroad_isPlayerFirstTime', JSON.stringify({
            isPlayerFirstTime: value,
        }));
    }

    public static highscore: number = 0;

    public static getPlayerHighscoreMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_highscore');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerHighscoreMetaData(SDKManager.highscore);
        } else {
            SDKManager.highscore = Number(data.highscore);
        }
    }

    public static setPlayerHighscoreMetaData(value: number) {
        localStorage.setItem('hammerplay_rampageroad_highscore', JSON.stringify({
            highscore: value,
        }));
    }

    public static coins: number = 0;

    public static getPlayerCoinsMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_coins');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerHighscoreMetaData(SDKManager.coins);
        } else {
            SDKManager.coins = Number(data.coins);
        }
    }

    public static setPlayerCoinsMetaData(value: number) {
        localStorage.setItem('hammerplay_rampageroad_coins', JSON.stringify({
            coins: value,
        }));
        window.gameEvents.emit("onDisableLoadingScreen");
    }

    public static carEquipped: number = 0;
    public static defaultCarEquippedStatus: any = [{ "bought": true, "isEquipped": true, "cost": 0 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 3500 },
    { "bought": false, "isEquipped": false, "cost": 3500 },
    { "bought": false, "isEquipped": false, "cost": 4500 },
    { "bought": false, "isEquipped": false, "cost": 4500 }];
    public static carEquippedStatus: any = SDKManager.defaultCarEquippedStatus;

    public static getPlayerCarEquippedMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_carEquipped');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerCarEquippedMetaData(SDKManager.carEquipped);
        } else {
            SDKManager.carEquipped = data.carEquipped;
        }
    }

    public static setPlayerCarEquippedMetaData(value: number) {
        localStorage.setItem('hammerplay_rampageroad_carEquipped', JSON.stringify({
            carEquipped: value,
        }));
    }

    public static getPlayerCarEquippedStatusMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_carEquippedStatus');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerCarEquippedStatusMetaData(SDKManager.defaultCarEquippedStatus);
        } else {
            let updateData = false;
            SDKManager.carEquippedStatus = data.carEquippedStatus;
            if (SDKManager.carEquippedStatus.length < SDKManager.defaultCarEquippedStatus.length) {
                updateData = true;
                for (let i = SDKManager.carEquippedStatus.length; i < SDKManager.defaultCarEquippedStatus.length; i++) {
                    SDKManager.carEquippedStatus[i] = SDKManager.defaultCarEquippedStatus[i];
                }
            }
            for (let index = 0; index < SDKManager.carEquippedStatus.length; index++) {
                if (SDKManager.carEquippedStatus[index].cost != SDKManager.defaultCarEquippedStatus[index].cost) {
                    updateData = true;
                    SDKManager.carEquippedStatus[index].cost = SDKManager.defaultCarEquippedStatus[index].cost;
                }
            }
            if (updateData) {
                SDKManager.setPlayerCarEquippedStatusMetaData(SDKManager.carEquippedStatus);
            }
        }
    }

    public static setPlayerCarEquippedStatusMetaData(value: any) {
        localStorage.setItem('hammerplay_rampageroad_carEquippedStatus', JSON.stringify({
            carEquippedStatus: value,
        }));
    }

    public static mapEquipped = 0;
    public static defaultMapEquippedStatus = [{ "bought": true, "isEquipped": true, "cost": 0 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 2500 }];
    public static mapEquippedStatus = SDKManager.defaultMapEquippedStatus;

    public static getPlayerMapEquippedMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_mapEquipped');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerMapEquippedMetaData(SDKManager.mapEquipped);
        }
        else {
            SDKManager.mapEquipped = data.mapEquipped;
        }
    }

    public static setPlayerMapEquippedMetaData(value: number) {
        localStorage.setItem('hammerplay_rampageroad_mapEquipped', JSON.stringify({
            mapEquipped: value,
        }));
    }

    static getPlayerMapEquippedStatusMetaData() {
        let data = localStorage.getItem('hammerplay_rampageroad_mapEquippedStatus');
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerMapEquippedStatusMetaData(SDKManager.defaultMapEquippedStatus);
        }
        else {
            let updateData = false;
            SDKManager.mapEquippedStatus = data.mapEquippedStatus;
            if (SDKManager.mapEquippedStatus.length < SDKManager.defaultMapEquippedStatus.length) {
                updateData = true;
                for (let i = SDKManager.mapEquippedStatus.length; i < SDKManager.defaultMapEquippedStatus.length; i++) {
                    SDKManager.mapEquippedStatus[i] = SDKManager.defaultMapEquippedStatus[i];
                }
            }
            for (let index = 0; index < SDKManager.mapEquippedStatus.length; index++) {
                if (SDKManager.mapEquippedStatus[index].cost != SDKManager.defaultMapEquippedStatus[index].cost) {
                    updateData = true;
                    SDKManager.mapEquippedStatus[index].cost = SDKManager.defaultMapEquippedStatus[index].cost;
                }
            }
            if (updateData) {
                SDKManager.setPlayerMapEquippedStatusMetaData(SDKManager.mapEquippedStatus);
            }
        }
    }

    public static setPlayerMapEquippedStatusMetaData(value: any) {
        localStorage.setItem('hammerplay_rampageroad_mapEquippedStatus', JSON.stringify({
            mapEquippedStatus: value,
        }));
    }
}

export var base64ImageURL: string = "";

export const ImageToDataURL = (imageURL) => {
    base64ImageURL = imageURL;
}